import { GM_PRICE_APPROVAL, GM_PRICE_APPROVAL_SUCCESS, GM_PRICE_APPROVAL_ERROR, GM_PRICE_APPROVAL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GmPriceApproval = (state = initialState, action) => {
  switch (action.type) {
    case GM_PRICE_APPROVAL:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GM_PRICE_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GM_PRICE_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GM_PRICE_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GmPriceApproval;
